import { createFileRoute, redirect } from "@tanstack/react-router";

import { SitePicker } from "../../../areas/owner/home/OwnerPages";
import { meQuery } from "../../../shared/auth/me";

/**
 * `/portal` (FR-FE12-02): one site → its dashboard; several → picker; none → empty state. The
 * count comes from the session's linked sites (BE-05 `owner_sites`, the same set as
 * `GET /v1/owner/sites`) so the entry chunk does not carry the owner data layer.
 */
export const Route = createFileRoute("/portal/_owner/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    const sites = me?.owner?.sites ?? [];
    if (sites.length === 1 && sites[0]) {
      throw redirect({
        to: "/portal/sites/$siteId",
        params: { siteId: sites[0].id },
        replace: true,
      });
    }
  },
  component: SitePicker,
});
